import { render, staticRenderFns } from "./CrosswordClueLengthFilter.vue?vue&type=template&id=567f2672&scoped=true&"
import script from "./CrosswordClueLengthFilter.vue?vue&type=script&lang=js&"
export * from "./CrosswordClueLengthFilter.vue?vue&type=script&lang=js&"
import style0 from "./CrosswordClueLengthFilter.vue?vue&type=style&index=0&id=567f2672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567f2672",
  null
  
)

export default component.exports